import React, { useEffect, useState } from "react";
import { EditOutlined } from "@ant-design/icons";
import DateRangeField from "../../CoreComponents/DateRangeField";
import Stat from "./Stat";
import { showMessage } from "../../Functionalities/Functions";
import { fetchSalaryTotals, periodLabel } from "./salaryTotalsData";
import { Empty, money, riderCount } from "./settlementParts";
import SubmittedSalariesTable from "./SubmittedSalariesTable";

const NO_TOTALS = { riders: 0, days: 0, orders: 0, salary: 0, cash_collected: 0, cash_in_hand: 0 };

const EnrollButton = ({ onClick }) => (
  <button type="button" className="stl-btn stl-btn--primary" onClick={onClick}>
    <EditOutlined /> Enroll Salaries
  </button>
);

export default function SubmittedSalaries({ range, onRangeChange, onEnroll }) {
  const [data, setData] = useState({ riders: [], totals: null });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let live = true;
    setLoading(true);
    fetchSalaryTotals(range).then((result) => {
      if (!live) return;
      setData(result);
      setLoading(false);
      if (result.error) showMessage(result.error, "danger", "Could not load the salaries", "top", "top-right");
    });
    return () => {
      live = false;
    };
  }, [range]);

  const totals = data.totals || NO_TOTALS;
  const period = periodLabel(range);
  const hasRows = data.riders.length > 0;

  return (
    <div className="container-fluid stl">
      <section className="stl-card stl-toolbar">
        <div className="stl-field">
          <span className="stl-field__label">Days</span>
          <DateRangeField label="Days" value={range} onChange={(next) => next && onRangeChange(next)} allowClear={false} />
        </div>
        <span className="stl-toolbar__end">
          <EnrollButton onClick={onEnroll} />
        </span>
      </section>

      <section className="stl-stats">
        <Stat label="Orders" value={totals.orders} hint={period} />
        <Stat label="Total salary" value={money(totals.salary)} hint={`${totals.days} salaries submitted`} />
        <Stat label="Cash collected" value={money(totals.cash_collected)} hint="from these days' orders" />
        <Stat label="Cash in hand now" value={money(totals.cash_in_hand)} hint={`held by ${riderCount(totals.riders)}`} />
      </section>

      <section className="stl-card stl-table-card">
        <div className="stl-table-bar">
          <div className="stl-table-bar__title">
            <h2 className="stl-title">Submitted salaries</h2>
            <span className="stl-subtitle">
              {period}
              {hasRows && ` · ${riderCount(totals.riders)}`}
            </span>
          </div>
        </div>

        {loading ? (
          <Empty title="Loading…" text={`Salaries submitted for ${period}.`} />
        ) : !hasRows ? (
          <Empty title={`No salaries submitted for ${period}`} text={data.error || "Enroll salaries to work out each rider's pay and send it."}>
            <EnrollButton onClick={onEnroll} />
          </Empty>
        ) : (
          <SubmittedSalariesTable riders={data.riders} totals={data.totals} />
        )}

        <p className="stl-footnote">
          Cash collected − salary − cash submitted is what each rider kept from these days. Cash in hand now is what they hold today, older days and
          today's orders included.
        </p>
      </section>
    </div>
  );
}
